<template>
  <div class="mall-section-title">
    <span class="typo-md-semi">{{ title }}</span>
    <div class="mall-section-title__more" @click="$emit('more-click')">
      <span class="mall-section-title__more-text">자세히보기</span>
      <img src="@/assets/mall/icn_caret_right.svg" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MallSectionTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.mall-section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mall-section-title__more {
  display: flex;
  padding: 0 2px;
  align-items: center;
  gap: 2px;
  border-radius: 4px;
  cursor: pointer;
}

.mall-section-title__more-text {
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  text-decoration: underline;
  white-space: nowrap;
}

.mall-section-title__more img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallSectionTitle.vue